export default {
  nav: {
    home: 'Accueil',
    categories: 'Catégories',
    shoppingGuide: 'Guide d’achat',
    explore: 'Explorer la feuille',
  },
  hero: {
    badge: 'Ressource d’information indépendante',
    title: 'USFans Spreadsheet — guide, liste des créateurs et informations clés',
    subtitle:
      'Une source organisée de guides, de comparaisons et de ressources sur les créateurs, l’expédition, les coupons et la sécurité USFans, le tout au même endroit.',
    ctaSpreadsheet: 'USFans Spreadsheet',
    ctaBuy: 'Acheter maintenant',
    mockupTitle: 'Feuille des créateurs',
    mockupSearch: 'Rechercher des créateurs...',
    mockupColCategory: 'Catégorie',
    mockupColName: 'Nom',
    mockupColStatus: 'Statut',
    mockupStatusActive: 'Actif',
    mockupStatusNew: 'Nouveau',
    mockupNote: 'Trié par catégorie · filtrable',
  },
  trust: {
    title: 'Pourquoi utiliser une feuille USFans ?',
    item1Title: 'Informations à jour',
    item1Desc: 'Nous gardons les guides, comparaisons et ressources frais et pertinents.',
    item2Title: 'Informations claires',
    item2Desc: 'Organisées en catégories faciles à parcourir.',
    item3Title: 'La sécurité d’abord',
    item3Desc: 'Ne partagez jamais mots de passe, codes de vérification ni données sensibles.',
    item4Title: 'Guide indépendant',
    item4Desc: 'Contenu informatif — pas un site officiel USFans.',
  },
  categories: {
    title: 'Parcourir par catégorie',
    subtitle: 'Choisissez une catégorie pour explorer toute la collection sur notre boutique principale.',
    dropdownLabel: 'Choisir une catégorie',
    dropdownHint: 'Sélectionnez une catégorie pour l’ouvrir',
    items: {
      shoes: 'Chaussures',
      hoodies: 'Hoodies et pulls',
      tshirts: 'T-shirts',
      jackets: 'Vestes',
      pants: 'Pantalons et shorts',
      headwear: 'Couvre-chefs',
      sets: 'Ensembles',
      underwear: 'Sous-vêtements',
      jersey: 'Maillots',
      accessories: 'Accessoires',
      bags: 'Sacs',
      belts: 'Ceintures',
      perfumes: 'Parfums',
      other: 'Autres',
    },
  },
  about: {
    title: 'Qu’est-ce que USFans Spreadsheet ?',
    lead:
      'USFans Spreadsheet est une manière structurée de parcourir et d’organiser les informations sur les créateurs, les ressources et les guides liés à la plateforme USFans.',
    p1: 'Notre objectif est de vous aider à trouver ce dont vous avez besoin sans chercher sur de nombreuses pages différentes. Grâce à une présentation claire, vous pouvez comparer les créateurs, consulter les catégories et accéder directement à la bonne source.',
    p2: 'Les feuilles sont particulièrement utiles aux débutants qui veulent d’abord une vue d’ensemble, avant d’approfondir des créateurs ou des ressources précis.',
    listTitle: 'Avantages clés :',
    list: [
      'Informations organisées au même endroit',
      'Recherche et filtrage plus rapides',
      'Guides adaptés aux débutants',
      'Comparaisons côte à côte',
      'Notes de sécurité à jour',
      'Structure actualisable et partageable',
    ],
  },
  articleCta: {
    title: 'Lisez le guide complet USFans Spreadsheet',
    subtitle:
      'Découvrez les listes de créateurs, les annuaires, les comparaisons et les conseils de sécurité dans notre guide.',
    button: 'Ouvrir le guide',
  },
  articles: {
    title: 'Guides et ressources USFans',
    subtitle: 'Des guides détaillés sur les avis, l’expédition, les coupons, l’entrepôt, la sécurité et plus encore.',
    readMore: 'Lire le guide',
  },
  footer: {
    disclaimer:
      'USFansLink est une ressource d’information indépendante et n’est ni affilié ni exploité par USFans.',
    rights: 'Tous droits réservés.',
    backHome: 'Accueil',
    mainSite: 'Visiter le site principal',
  },
};